import reducer from './reducers';

export { default as buildingsSelectors } from './selectors';
export { default as buildingsOperations } from './operations';
export { default as buildingsTypes } from './types';

export default reducer;
